module.exports = __webpack_public_path__ + "static/media/loading.dfa2d7ab.gif";